const GROQ_API_KEY = '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';
const GROQ_URL = 'https://api.groq.com/openai/v1/chat/completions';

export async function askGemini(prompt) {
  try {
    const response = await fetch(GROQ_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${GROQ_API_KEY}`
      },
      body: JSON.stringify({
        model: 'llama-3.1-8b-instant',
        messages: [
          {
            role: 'system',
            content: 'You are a helpful professional assistant for Iyanna Foundation Tanzania NGO that mentors primary school children Classes 1 to 7.'
          },
          {
            role: 'user',
            content: prompt
          }
        ],
        max_tokens: 1500,
        temperature: 0.7,
      })
    });

    if (!response.ok) {
      const errData = await response.json();
      console.error('Groq API error:', errData);
      return 'AI is not available right now. Please try again later.';
    }

    const data = await response.json();

    if (data.choices && data.choices[0] && data.choices[0].message) {
      return data.choices[0].message.content;
    } else {
      return 'AI is not available right now. Please try again.';
    }
  } catch (err) {
    console.error('Groq connection error:', err);
    return 'AI is not available right now. Please check your connection.';
  }
}

export default GROQ_API_KEY;